import React from "react";
import './Card.css';
import { Link, useLocation } from 'react-router-dom';

function Card(props) {
  const location = useLocation();
  const basePath = location.pathname.split("/")[1];

  return (
    <div className="custom-card">
      <div className="card-content">
        <div className="card-icon">
          <img
            src={props.val.logo}
            alt="Logo"
            className="card-logo"
          />
        </div>
        <div className="card-info">
          <h3 className="card-title">{props.val.title}</h3>
          <p className="card-tagline">{props.val.tagline}</p>
        </div>
      </div>
      <Link to={`/${basePath}/${props.val.title.toLowerCase()}`} className="stretched-link" />
    </div>
  );
}

export default Card;